import { useApiQuery } from '@BUP/hooks/useApiQuery'

export const useGetPeriodPreferences = (periodId) => {
  const query = useApiQuery(
    ['courseAssignmentPeriodPreferences', periodId],
    'schools',
    client => client.get(`/current-organization/course-assignment/periods/${periodId}/preferences`),
    { enabled: !!periodId },
    { authenticated: true, version: 5 }
  )

  return {
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    preferences: query.data?.preferences ?? [],
    error: query.error,
    refetch: query.refetch
  }
}
